/* healmeal – "Warenkorb anzeigen"-Button in der Sticky-Progress-Bar.
   Injiziert den Button (damit die grosse Progress-Bar-Section unangetastet
   bleibt) und oeffnet damit den Warenkorb-Drawer. Label kommt aus
   window.__hmCfg.viewCartLabel (uebersetzbar). */
(function () {
  if (window.__hmCtaInit) { return; }
  window.__hmCtaInit = true;

  function label() {
    return (window.__hmCfg && window.__hmCfg.viewCartLabel) || 'Warenkorb anzeigen';
  }

  function injectCta() {
    var bar = document.querySelector('.hm-pb');
    if (!bar) { return; }
    var existing = bar.querySelector('.hm-pb__cta');
    if (existing) { existing.textContent = label(); return; }
    var prog = bar.querySelector('#hm-progress');
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'hm-pb__cta';
    btn.setAttribute('data-hm-open-cart', '');
    btn.textContent = label();
    if (prog && prog.parentNode === bar) {
      var inner = document.createElement('div');
      inner.className = 'hm-pb__inner';
      bar.insertBefore(inner, prog);
      inner.appendChild(prog);
      inner.appendChild(btn);
    } else {
      bar.appendChild(btn);
    }
  }

  function openCart() {
    var d = document.querySelector('cart-drawer');
    if (d && typeof d.open === 'function') { d.open(); }
    else { window.location.href = '/cart'; }
  }

  document.addEventListener('click', function (e) {
    var b = (e.target && e.target.closest) ? e.target.closest('[data-hm-open-cart]') : null;
    if (b) { e.preventDefault(); openCart(); }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectCta);
  } else {
    injectCta();
  }
  setTimeout(injectCta, 1200);
})();
